/*
  Ivy Pillow — offset-productslider: de pijlen scrollen de rij één kaart
  per klik; het scrollen zelf is native met scroll-snap (§13.6).
*/
(() => {
  function initIvyProductSlider(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('.ivy-product-slider').forEach((sectie) => {
      if (sectie.dataset.ivyInit === 'true') return;
      sectie.dataset.ivyInit = 'true';

      const track = sectie.querySelector('.ivy-product-slider__track');
      if (!track) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sectie.querySelectorAll('.ivy-product-slider__pijl').forEach((pijl) => {
        pijl.addEventListener('click', () => {
          const item = track.querySelector('.ivy-product-slider__item');
          if (!item) return;
          const stap = item.getBoundingClientRect().width + 20;
          track.scrollBy({
            left: stap * Number(pijl.dataset.richting || 1),
            behavior: reduce ? 'auto' : 'smooth',
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initIvyProductSlider(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initIvyProductSlider(e.target));
  }
})();
